import React from 'react';
import { setIsAgentOfficeContactPopupOpen } from 'store/state/app/actions';
import AgentPage, { AgentPageProps } from './AgentPage';
import { connect } from 'react-redux';
import { State } from 'store/state';
import {
  agentBulletinsDataSelector,
  agentPageDataSelector,
  agentPageDealsSelector,
} from 'store/state/domainData/selectors/agentById';
import { officeBulletinsDataSelector, officePageDataSelector } from 'store/state/domainData/selectors/officeById';
import { contactPageResponseSelector } from 'store/state/mutationsResponse/selectors';
import withEvents from 'analytics/withEvents';
import { leadingAgentAwardDataSelector } from 'store/state/domainData/selectors/searchAgentAwardsByIds';
import { routeSelector } from 'store/state/selectors/router';
import { keyBy } from 'lodash';


const mapDispatchToProps = {
  setContactOpen: setIsAgentOfficeContactPopupOpen,
};

const mapStateToProps = (state: State) => {
  const mainData = agentPageDataSelector(state);
  const officeData = officePageDataSelector(state);
  const leadingAgentData = leadingAgentAwardDataSelector(state);
  const route = routeSelector(state);
  const contactResponse = mainData ? contactPageResponseSelector(state, mainData.agentId) : null;
  const isContacted = Boolean(contactResponse && contactResponse.data && contactResponse.data.contactV4);
  const officeBulletins = officeBulletinsDataSelector(state);
  const agentBulletins = agentBulletinsDataSelector(state);
  const agentDeals = agentPageDealsSelector(state);

  let listings = null;
  if (officeData && officeBulletins && agentBulletins) {
    const bulletinsMap = keyBy([ ...officeBulletins.bulletins, ...officeBulletins.commercialBulletins ], b => 'id' in b && b.id);

    if (officeData.allOfficeBulletinsInAgentPage) {
      listings = { ...officeBulletins, spotlightListings: agentBulletins.spotlightListings, deals: agentBulletins.deals, bulletinsMap };
    }
    else {
      listings = { ...agentBulletins, bulletinsMap };
    }
  }

  return {
    isContacted,
    mainData,
    officeData,
    route,
    listings,
    leadingAgentData,
    agentDeals,
  };
};

const Agent: React.FC<AgentPageProps> = (props) => {
  if (!props.mainData || !props.officeData) return null;
  return <AgentPage {...props}/>;
};


const AgentWithEvents = withEvents<AgentPageProps>((sendEvent, { mainData, officeData, leadingAgentData }) => ({
  setContactOpen: () => {
    sendEvent('user_contact_me_form_open', 'user', {
      event: {
        agent_details: {
          id: mainData.agentId,
          name: mainData.name,
          office_id: mainData.officeId,
          office_name: officeData.officeName,
          is_leading_agent: Boolean(leadingAgentData.isLeadingAgent),
          phone_number: officeData.officeConnectionInAgentPage || !mainData.virtualPhone
            ? officeData.virtualPhone
            : mainData.virtualPhone,
        },
        source: 'agent_page',
      },
    });
  },
}))(Agent);

export default connect(mapStateToProps, mapDispatchToProps)(AgentWithEvents);

